import { intersection } from "lodash";
import moment from "moment";
import store from "~/redux/store";

export const refTable = {
    days: ["Montag", "Dienstag", "Mittwoch", "Donnerstag", "Freitag", "Samstag", "Sonntag"],
    times: [
        "00:00",
        "00:15",
        "00:30",
        "00:45",
        "01:00",
        "01:15",
        "01:30",
        "01:45",
        "02:00",
        "02:15",
        "02:30",
        "02:45",
        "03:00",
        "03:15",
        "03:30",
        "03:45",
        "04:00",
        "04:15",
        "04:30",
        "04:45",
        "05:00",
        "05:15",
        "05:30",
        "05:45",
        "06:00",
        "06:15",
        "06:30",
        "06:45",
        "07:00",
        "07:15",
        "07:30",
        "07:45",
        "08:00",
        "08:15",
        "08:30",
        "08:45",
        "09:00",
        "09:15",
        "09:30",
        "09:45",
        "10:00",
        "10:15",
        "10:30",
        "10:45",
        "11:00",
        "11:15",
        "11:30",
        "11:45",
        "12:00",
        "12:15",
        "12:30",
        "12:45",
        "13:00",
        "13:15",
        "13:30",
        "13:45",
        "14:00",
        "14:15",
        "14:30",
        "14:45",
        "15:00",
        "15:15",
        "15:30",
        "15:45",
        "16:00",
        "16:15",
        "16:30",
        "16:45",
        "17:00",
        "17:15",
        "17:30",
        "17:45",
        "18:00",
        "18:15",
        "18:30",
        "18:45",
        "19:00",
        "19:15",
        "19:30",
        "19:45",
        "20:00",
        "20:15",
        "20:30",
        "20:45",
        "21:00",
        "21:15",
        "21:30",
        "21:45",
        "22:00",
        "22:15",
        "22:30",
        "22:45",
        "23:00",
        "23:15",
        "23:30",
        "23:45",
    ],
};

export const timeDivisions = { ...refTable, times: [...refTable.times, "23:59"] };

export const checkGroupsForOverlapping = (groups) => {
    let overlappingGroups = [];

    Object.keys(groups).forEach((key) => {
        if (key !== "open") {
            let slots = groups[key].map((g) => Number(g.slot));

            let duplicateSlot = -1;
            for (let i = 0; i < slots.length; i++) {
                for (let j = i + 1; j < slots.length; j++) {
                    if (slots[i] == slots[j]) duplicateSlot = slots[i];
                }
            }

            if (duplicateSlot !== -1) {
                overlappingGroups = [...overlappingGroups, groups[key].filter((g) => Number(g.slot) === duplicateSlot)];
            }
        }
    });

    return overlappingGroups;
};

export const getDateFromSlot = (rowIndex, colIndex) => {
    const time = refTable.times[rowIndex].split(":");
    return moment().set({ isoWeekday: colIndex, hours: time[0], minutes: time[1] });
};

export const getAvailableSlots = (users, ...timeslots) => {
    let availableSlots = intersection(...users?.map((u) => u.timeslots));
    if (timeslots.every((ts) => ts !== undefined && ts !== null))
        availableSlots = intersection(availableSlots, ...timeslots);
    return availableSlots;
};

export const getAvailableSlotsCount = (users) => {
    return getAvailableSlots(users)?.length;
};

export const getMaxSlotsizePerColumn = (col, groups = {}) => {
    let max = 0;
    refTable.times.forEach((time, index) => {
        let length = (groups[[col, index].join("-")] || []).length;
        if (length > max) {
            max = length;
        }
    });
    return max;
};

export const getDublicateInCol = (col, user) => {
    const { table, plan } = store.getState().trainingPlan;
    let duplicate = 0;

    if (plan) {
        for (let i = 0; i < table.rows.length; i++) {
            let key = i + "-" + col;
            if (plan[key] && plan[key].some((group) => group.members.some((u) => u.id === user.id))) {
                duplicate++;
            }
        }
    }

    return duplicate > 1;
};

export const getDublicateTrainerInSlot = (slot, group) => {
    // const { plan } = store.getState().trainingPlan;
    // let found = false;

    // if (slot !== "conflicts" && plan && group.trainer && group.trainer.id) {
    //     let slotArr = slot.split("-");

    //     for (let i = 0; i < group.timeslotsNeeded; i++) {
    //         let key = `${Number(slotArr[0]) + i}-${slotArr[1] + i}`;
    //         plan[key].forEach((g) => {
    //             if (g.trainer && g.trainer.id && g.trainer.id === group.trainer.id) {
    //                 found = true;
    //             }
    //         });
    //     }
    // }

    // return found;

    return false;
};

export const getMissingGroupings = (user, groups) => {
    let groupsWithUser = groups.filter((g) => g.members.find((m) => m.id === user.id));
    let missingGrouping = [];

    user.trainings.forEach((training) => {
        if (training) {
            let groupFound;
            for (let i = 0; i < groupsWithUser.length; i++) {
                let group = groupsWithUser[i];
                if (String(group.members?.length) === training) {
                    groupFound = group;
                    break;
                }
            }

            if (!groupFound) {
                missingGrouping.push(training);
            } else {
                groupsWithUser = groupsWithUser.filter((g) => g.id !== groupFound.id);
            }
        }
    });

    if (user.trainings.includes("") || user.trainings.includes(null)) {
        user.trainings
            .filter((t) => !t || t === "")
            .forEach(() => {
                if (groupsWithUser.length + missingGrouping.length < user.trainings.length) {
                    missingGrouping.push("Zufällige");
                }
            });
    }

    return missingGrouping;
};

export const getTimesUserIsAssignedPerDay = (user, slot) => {
    const state = store.getState();
    const table = state.trainingPlan?.settings?.table;
    const groups = state.trainingPlan?.groups;
    const day = slot.split("-")[1];
    let found = 0;

    if (table) {
        for (let i = table.times[0]; i < table.times[1]; i++) {
            found += groups[i + "-" + day]?.filter((g) => g.members?.some((u) => u.id === user.id))?.length || 0;
        }
    }

    return found;
};

export const getOverlappingUsersPerInterval = (users, col, interval) => {
    let overlapping = [];

    for (let i = interval[0]; i <= interval[1]; i++) {
        users
            .filter((user) => user.timeslots?.includes([i, col].join("-")))
            .forEach((user) => {
                if (overlapping.every((u) => u.id !== user.id)) {
                    overlapping.push(user);
                }
            });
    }

    return overlapping;
};

export const getTimeSlots = (users, table) => {
    let timeslots = [];
    getAvailableSlots(users, table).forEach((r, ri) => {
        r.forEach((c, ci) => {
            if (c) {
                timeslots.push([ri, ci]);
            }
        });
    });
    return timeslots;
};
